import { render, staticRenderFns } from "./system_school_infomation.vue?vue&type=template&id=557b9cf4&scoped=true&"
import script from "./system_school_infomation.vue?vue&type=script&lang=js&"
export * from "./system_school_infomation.vue?vue&type=script&lang=js&"
import style0 from "./system_school_infomation.vue?vue&type=style&index=0&id=557b9cf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b9cf4",
  null
  
)

export default component.exports